import CustomSweetAlert from '../common/customSweetAlert/CustomSweetAlert';
import {
  getFoodLogDetails,
  addFoodMenuData,
  addFoodImage,
  addFoodLogData,
  getTargetCaloriesData,
  getLogListData,
  deleteFoodAndSupplement,
  editFoodMenuData,
  deleteFoodMenuData,
  modifyFoodLogData,
} from '../services/healthWellness/foodLog.service';
import {
  ADD_FOOD_IMAGE,
  ADD_FOOD_LOG,
  ADD_FOOD_MENU,
  GET_TARGET_CALORIES,
  GET_LOG_LIST,
  DELETE_FOOD_LOG,
  EDIT_FOOD_MENU,
  MODIFY_FOOD_LOG,
  DELETE_FOOD_MENU,
} from './types';

export const fetchFoodLogDetails = () => (dispatch) =>
  getFoodLogDetails()
    .then((result) => {
      dispatch({
        // type: GET_FOOD_CATEGORIES,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const addFoodMenuDetails = (foodMenuData) => (dispatch) =>
  addFoodMenuData(foodMenuData)
    .then((result) => {
      dispatch({
        type: ADD_FOOD_MENU,
        payload: { foodMenuData },
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const editFoodMenuDetails = (foodMenuData, id) => (dispatch) =>
  editFoodMenuData(foodMenuData, id)
    .then((result) => {
      dispatch({
        type: EDIT_FOOD_MENU,
        payload: { foodMenuData },
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const deleteFoodMenuDetails = (foodMenuData, foodLogId) => (dispatch) =>
  deleteFoodMenuData(foodMenuData, foodLogId)
    .then((result) => {
      dispatch({
        type: DELETE_FOOD_MENU,
        payload: { foodMenuData },
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const uploadFoodImage = (image) => (dispatch) =>
  addFoodImage(image)
    .then((result) => {
      dispatch({
        type: ADD_FOOD_IMAGE,
        payload: { image },
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const addFoodLog = (id, type, myFoodWeight, foodData, suggestGoalPayload) =>
  (dispatch) =>
    addFoodLogData(id, type, myFoodWeight, foodData, suggestGoalPayload)
      .then((result) => {
        dispatch({
          type: ADD_FOOD_LOG,
          payload: { id, type, myFoodWeight },
        });
        return result;
      })
      .catch(function (error) {
        CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
        throw new Error(error);
      });

export const modifyFoodLog = (id, foodData) => (dispatch) =>
  modifyFoodLogData(id, foodData)
    .then((result) => {
      dispatch({
        type: MODIFY_FOOD_LOG,
        payload: foodData,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
      throw new Error(error);
    });

export const getTargetCalories = () => (dispatch) =>
  getTargetCaloriesData()
    .then((result) => {
      dispatch({
        type: GET_TARGET_CALORIES,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const getLogList = (params) => (dispatch) =>
  getLogListData(params)
    .then((result) => {
      dispatch({
        type: GET_LOG_LIST,
        payload: result,
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
    });

export const deleteFoodAndSupplementProducts = (myFoodWeightId) => (dispatch) =>
  deleteFoodAndSupplement(myFoodWeightId)
    .then((result) => {
      dispatch({
        type: DELETE_FOOD_LOG,
        payload: { myFoodWeightId },
      });
      return result;
    })
    .catch(function (error) {
      CustomSweetAlert({
        title: "",
        text: error.message,
        confirmButtonText: "ตกลง",
      });
      throw new Error(error);
    });
